import { CustomButton } from '@ui-kit'
import { FORM_CONSTANTS } from '../../constants/form.constants'
import { NAMESPACES } from '../../utils/constants'
export const HybridLayoutActions = () => {
  return (
    <div className="flex gap-2 justify-end">
      <CustomButton type="button" variant="primary">
        {NAMESPACES.CANCEL_BUTTON}
      </CustomButton>
      <CustomButton
        type="submit"
        id={FORM_CONSTANTS.SAVE_AS_DRAFT}
        variant="primary"
      >
        {NAMESPACES.SAVE_AS_DRAFT}
      </CustomButton>
      <CustomButton type="submit" variant="primary" isFilled>
        {NAMESPACES.SAVE_BUTTON}
      </CustomButton>
    </div>
  )
}
